import { useSelector } from 'react-redux';

export const useContainer = () => {
  const companyInfo = useSelector((st) => st.company.companyInfo);

  return {
    companyInfo,
  };
};
